import {CanActivateFn, Router} from '@angular/router';
import {CommonService} from "../services/common.service";
import {inject} from "@angular/core";

export const authGuard: CanActivateFn = (route, state) => {
  const commonService = inject(CommonService);
  const router = inject(Router);

  if (commonService.isLoggedIn()) {
    return true;
  } else {
    router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
    return false;
  }
};
